<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.4072 14.245C11.7352 14.586 12.2652 14.586 12.5932 14.245L15.8842 10.308C16.1482 9.993 15.9322 9.5 15.5312 9.5H8.46917C8.06717 9.5 7.85217 9.993 8.11617 10.308L11.4072 14.245Z"/>
</svg>
